{
  "common": {
    "customer": "Kunde",
    "days": "Tage",
    "error": "Ein Fehler ist aufgetreten",
    "goHome": "Zur Startseite",
    "loading": "Lädt...",
    "login": "Anmelden",
    "site": {
      "1": "Malmédy",
      "2": "Trucks - Livange",
      "3": "Bus - Livange"
    },
    "vehicle": "Fahrzeug"
  },
  "pages": {
    "login": {
      "pageTitle": "Anmelden"
    },
    "notFound": {
      "message": "Seite nicht gefunden",
      "title": "Hoppla"
    },
    "dashboard": {
      "title": "Widget-Elemente",
      "createButton": "Neues Widget",
      "noData": "Keine Elemente gefunden",
      "columns": {
        "name": "Name",
        "description": "Beschreibung",
        "status": "Status",
        "createdOn": "Erstellt am"
      },
      "status": {
        "active": "Aktiv",
        "inactive": "Inaktiv"
      },
      "createTitle": "Widget-Element erstellen",
      "form": {
        "name": "Name",
        "description": "Beschreibung",
        "isActive": "Aktiv",
        "nameRequired": "Name ist erforderlich."
      }
    }
  }
}
